var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26487 6.73536C7.41137 6.88186 7.41137 7.11938 7.26487 7.26588C7.19187 7.33888 7.09587 7.37587 6.99987 7.37587C6.90387 7.37587 6.80787 7.33938 6.73487 7.26588L3.99987 4.53086L1.26487 7.26588C1.19187 7.33888 1.09587 7.37587 0.999874 7.37587C0.903874 7.37587 0.807875 7.33938 0.734875 7.26588C0.588375 7.11938 0.588375 6.88186 0.734875 6.73536L3.46988 4.00038L0.734875 1.26539C0.588375 1.11889 0.588375 0.881375 0.734875 0.734875C0.881375 0.588375 1.11888 0.588375 1.26538 0.734875L4.00038 3.46989L6.73537 0.734875C6.88187 0.588375 7.11937 0.588375 7.26587 0.734875C7.41237 0.881375 7.41237 1.11889 7.26587 1.26539L4.53087 4.00038L7.26487 6.73536Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0ac4e3d9c7ae7b6921d6644b34829d82.svg";
export { ForwardRef as ReactComponent };